// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.popperClassT{z-index:999;padding:4px 4px;font-size:12px;text-align:center}", ""]);
// Exports
module.exports = exports;
